import React, { useEffect, useState } from 'react';
import { TextField, Button, Checkbox, FormControlLabel, Typography, Snackbar, Alert, CircularProgress, Box, Chip,MenuItem } from '@mui/material';
import { getDecryptedAccessToken, getDecryptedData } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import ApiServices from '../../../Utils/ApiServices/ApiServices';


const CreateMembershipPlan = () => {
  const accessToken = getDecryptedAccessToken();
  const LoginUserDetails = getDecryptedData();

  const [planTier, setPlanTier] = useState('');
  const [typeName, setTypeName] = useState('');
  const [category, setCategory] = useState('');
  const [benefitsList, setBenefitsList] = useState([]);
  const [selectedBenefits, setSelectedBenefits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  

  useEffect(() => {
    const fetchBenefits = async () => {
      try {
        const res = await ApiServices.get('/apis/default/api/membershipbenefits', {
        Authorization: `Bearer ${accessToken}`,
      });
        setBenefitsList(res.data || []);
      } catch (err) {
        console.error(err);
        setSnackbar({ open: true, message: 'Failed to load benefits', severity: 'error' });
      }
    };
    fetchBenefits();
  }, [accessToken]);

  const handleCheckboxChange = (benefitId) => {
    setSelectedBenefits(prev =>
      prev.includes(benefitId)
        ? prev.filter(id => id !== benefitId)
        : [...prev, benefitId]
    );
  };

  const handleRemoveSelected = (idToRemove) => {
    setSelectedBenefits(prev => prev.filter(id => id !== idToRemove));
  };

  // const handleSubmit = async () => {
  //   setLoading(true);
  //   const payload = {
  //     plan_tier: planTier,
  //     type_name: typeName,
  //     category: category,
  //     created_by: LoginUserDetails?.id,
  //     updated_by: LoginUserDetails?.id,
  //     benefit_ids: selectedBenefits
  //   };

  //   try {
  //     const response = await ApiServices.post('/apis/default/api/membership', payload,  {
  //       Authorization: `Bearer ${accessToken}`,
  //     });
  //     setSnackbar({ open: true, message: 'Membership Plan Created Successfully!', severity: 'success' });
  //     setPlanTier('');
  //     setTypeName('');
  //     setCategory('');
  //     setSelectedBenefits([]);
  //   } catch (error) {
  //     setSnackbar({ open: true, message: 'Error creating membership plan', severity: 'error' });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async () => {
  setLoading(true);

  // Calculate age_pricing totals
  const allRanges = [];

  selectedBenefits.forEach(id => {
    const benefit = benefitsList.find(b => b.id === id);
    benefit?.age_based_pricing?.forEach(range => {
      if (!allRanges.some(r => r.min === range.min_age && r.max === range.max_age)) {
        allRanges.push({ min: range.min_age, max: range.max_age });
      }
    });
  });

  allRanges.sort((a, b) => parseInt(a.min) - parseInt(b.min));

  const age_pricing = allRanges.map(range => {
    let sum = 0;
    selectedBenefits.forEach(id => {
      const benefit = benefitsList.find(b => b.id === id);
      const match = benefit?.age_based_pricing?.find(p =>
        p.min_age === range.min && p.max_age === range.max
      );
      if (match) sum += parseFloat(match.price);
    });
    return {
      min_age: range.min,
      max_age: range.max,
      price: sum
    };
  });

  const payload = {
    plan_tier: planTier,
    type_name: typeName,
    category: category,
    created_by: LoginUserDetails?.id,
    updated_by: LoginUserDetails?.id,
    benefit_ids: selectedBenefits,
    age_pricing: age_pricing
  };

  try {
    const response = await ApiServices.post('/apis/default/api/membership', payload, {
      Authorization: `Bearer ${accessToken}`,
    });
    setSnackbar({ open: true, message: 'Membership Plan Created Successfully!', severity: 'success' });
    setPlanTier('');
    setTypeName('');
    setCategory('');
    setSelectedBenefits([]);
  } catch (error) {
    setSnackbar({ open: true, message: 'Error creating membership plan', severity: 'error' });
  } finally {
    setLoading(false);
  }
};


  return (
    <Box p={2}>
      <Typography variant="h6" mb={2}>Create Membership Plan</Typography>

      <TextField fullWidth margin="normal" label="Plan Tier" value={planTier} onChange={e => setPlanTier(e.target.value)} />
      <TextField fullWidth margin="normal" label="Type Name" value={typeName} onChange={e => setTypeName(e.target.value)} />
      {/* <TextField fullWidth margin="normal" label="Category" value={category} onChange={e => setCategory(e.target.value)} /> */}
      <TextField
  select
  fullWidth
  margin="normal"
  label="Category"
  value={category}
  onChange={e => setCategory(e.target.value)}
>
  <MenuItem value="family">Family</MenuItem>
  <MenuItem value="business">Business</MenuItem>
  <MenuItem value="custom">Custom</MenuItem>
</TextField>


      <Box mt={3}>
        <Typography variant="subtitle1">Selected Benefits:</Typography>
        {selectedBenefits.length === 0 && <Typography variant="body2" color="text.secondary">No benefits selected</Typography>}
        <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
          {selectedBenefits.map(id => {
            const benefit = benefitsList.find(b => b.id === id);
            return (
              <Chip
                key={id}
                label={benefit?.benefit_name}
                onDelete={() => handleRemoveSelected(id)}
                color="primary"
              />
            );
          })}
        </Box>
      </Box>

      <Box mt={4}>
        <Typography variant="subtitle1">Available Benefits:</Typography>
        {benefitsList.map(benefit => (
          <FormControlLabel
            key={benefit.id}
            control={
              <Checkbox
                checked={selectedBenefits.includes(benefit.id)}
                onChange={() => handleCheckboxChange(benefit.id)}
              />
            }
            label={benefit.benefit_name}
          />
        ))}
      </Box>

{selectedBenefits.length > 0 && (
  <Box mt={4}>
    <Typography variant="subtitle1" mb={1}>Pricing by Age Range</Typography>
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          <th style={{ border: '1px solid #ccc', padding: '8px' }}>Benefit Name</th>
          {(() => {
            const allRanges = [];

            selectedBenefits.forEach(id => {
              const benefit = benefitsList.find(b => b.id === id);
              benefit?.age_based_pricing?.forEach(range => {
                if (!allRanges.some(r => r.min === range.min_age && r.max === range.max_age)) {
                  allRanges.push({ min: range.min_age, max: range.max_age });
                }
              });
            });

            allRanges.sort((a, b) => parseInt(a.min) - parseInt(b.min));
            return allRanges.map((range, i) => (
              <th key={i} style={{ border: '1px solid #ccc', padding: '8px' }}>
                {range.max !== null ? `${range.min} - ${range.max}` : `${range.min}+`}
              </th>
            ));
          })()}
        </tr>
      </thead>
      <tbody>
        {selectedBenefits.map(id => {
          const benefit = benefitsList.find(b => b.id === id);
          return (
            <tr key={id}>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{benefit?.benefit_name}</td>
              {(() => {
                const allRanges = [];

                selectedBenefits.forEach(id => {
                  const b = benefitsList.find(b => b.id === id);
                  b?.age_based_pricing?.forEach(range => {
                    if (!allRanges.some(r => r.min === range.min_age && r.max === range.max_age)) {
                      allRanges.push({ min: range.min_age, max: range.max_age });
                    }
                  });
                });

                allRanges.sort((a, b) => parseInt(a.min) - parseInt(b.min));

                return allRanges.map((range, idx) => {
                  const match = benefit?.age_based_pricing?.find(p =>
                    p.min_age === range.min && p.max_age === range.max
                  );
                  return (
                    <td key={idx} style={{ border: '1px solid #ccc', padding: '8px' }}>
                      {match ? `$${match.price}` : '—'}
                    </td>
                  );
                });
              })()}
            </tr>
          );
        })}
        {/* Row for total sum */}
        <tr style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
          <td style={{ border: '1px solid #ccc', padding: '8px' }}>Total</td>
          {(() => {
            const allRanges = [];

            selectedBenefits.forEach(id => {
              const benefit = benefitsList.find(b => b.id === id);
              benefit?.age_based_pricing?.forEach(range => {
                if (!allRanges.some(r => r.min === range.min_age && r.max === range.max_age)) {
                  allRanges.push({ min: range.min_age, max: range.max_age });
                }
              });
            });

            allRanges.sort((a, b) => parseInt(a.min) - parseInt(b.min));

            return allRanges.map((range, idx) => {
              let sum = 0;
              selectedBenefits.forEach(id => {
                const benefit = benefitsList.find(b => b.id === id);
                const match = benefit?.age_based_pricing?.find(p =>
                  p.min_age === range.min && p.max_age === range.max
                );
                if (match) sum += parseFloat(match.price);
              });
              return (
                <td key={idx} style={{ border: '1px solid #ccc', padding: '8px' }}>${sum}</td>
              );
            });
          })()}
        </tr>
      </tbody>
    </table>
  </Box>
)}



      <Box mt={3}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} />}
        >
          {loading ? 'Submitting...' : 'Create Plan'}
        </Button>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity={snackbar.severity}
          sx={{ width: '100%' }}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateMembershipPlan;
